import { Injectable, Injector } from "@angular/core";
import { BigNumber } from 'bignumber.js';
import { AppContext, FrameContext, Repository, ENTITY_TEMPLATE, ResolveService, ExpressionUtil, ExpressionExecutor } from "@farris/devkit";
import { Observable, of } from "rxjs";

@Injectable()
export class ExpressionService {
  constructor(private injector: Injector, private resolveService: ResolveService, private frameContext: FrameContext, private expressionExecutor: ExpressionExecutor) { }
  /**
   * æ§è¡è¡¨è¾¾å¼è®¡ç®
   * @param expression è¡¨è¾¾å¼
   * @param customContext èªå®ä¹ä¸ä¸æ
   * @returns 
   */
  public execute(expression: string, customContext?: { [prop: string]: any }): any {
    const deps = this.resolveService.resolve(expression);
    const groupDependencies = ExpressionUtil.getGroupFunctionDependency(expression, this.frameContext.repository.entityTypeInfo);
    const entityContext = this.buildEntityContext(deps, groupDependencies);
    const stateContext = this.buildStateContext();
    const context = {
      [this.entityOriginalNodeCode]: entityContext,
      ...stateContext,
      BigNumber,
      frameContext: this.frameContext,
      bindingData: this.frameContext.bindingData,
      repository: this.frameContext.repository,
      ...customContext
    }
    return this.expressionExecutor.eval(expression, context);
  }
  /**
   * æ§è¡è¡¨è¾¾å¼ï¼è¿åå¯è§å¯å¯¹è±¡ï¼
   * @param expression è¡¨è¾¾å¼
   * @param customContext èªå®ä¹ä¸ä¸æ
   * @returns 
   */
  public executeAsync(expression: string, customContext?: { [prop: string]: any }): Observable<any> {
    const result = this.execute(expression, customContext);
    return of(result);
  }
  /**
   * æé å®ä½ä¸ä¸æ
   * @param deps 
   * @param groupDependencies 
   * @param context 
   * @returns 
   */
  private buildEntityContext(deps: string[], groupDependencies: string[], context?: { [prop: string]: any }) {
    let isGroupdMainEntity = false;
    deps.forEach((dep: string) => {
      const isEntityDependency = this.isEntityDependency(dep);
      const isGroupDependency = groupDependencies.findIndex(item => item === dep) !== -1;
      // å¦æä¾èµçæ¯stateï¼æ éå¤çï¼ç°å¨éè¦ç¡®å®çæ¯è¿åå¤å°å®ä½çé®é¢ï¼åstateæ²¡æå³ç³»
      // è¡¨è¾¾å¼ä¾èµäºå®ä½
      if (isEntityDependency) {
        // æ¯èåä¾èµ
        if (isGroupDependency) {
          const dependencyLength = dep.split('/').filter(p => p).length - 1;
          if (dependencyLength === 1) {
            // èåäºä¸»è¡¨å­æ®µï¼ææä¸»è¡¨æ°æ®é½éè¦åä¸è¿ç®ï¼æ­¤æ¶å·²ç»ç¡®å®è®¡ç®çå®ä½ä¸ä¸æäºã
            isGroupdMainEntity = true;
          } else {
            // èåäºå­è¡¨å­æ®µï¼åªéè¦ä¼ éå½åå®ä½
          }
        } else {
          // å½åä¾èµä¸æ¯èåï¼åªéè¦ä¼ éå½åå®ä½
        }
      }
    });
    const data = this.getEntity();
    if (isGroupdMainEntity) {
      const collection = this.frameContext.repository.entityCollection.toJSON();
      data['__type__'] = 'List';
      data['__items__'] = collection;
    }
    return data;
  }
  /**
   * æ¯å¦ä¸ºå®ä½ä¾èµ
   * @param dep 
   * @returns 
   */
  private isEntityDependency(dep: string) {
    return dep.startsWith(ENTITY_TEMPLATE);
  }
  /**
   * è·åå®ä½
   * @param event 
   * @returns 
   */
  public getEntity() {
    const entityTypeInfo = this.frameContext.repository.entityTypeInfo;
    const bindingData = this.frameContext.bindingData;
    const childrenEntityPaths = [];
    ExpressionUtil.getChildrenEntityPaths(entityTypeInfo, childrenEntityPaths);
    const entity = this.frameContext.bindingData.list.currentItem.toJSON();
    entity['__type__'] = 'Entity';
    if (!childrenEntityPaths || childrenEntityPaths.length < 1) {
      return entity;
    }
    // æ¾å°ææå­è¡¨
    childrenEntityPaths.forEach((paths: string[]) => {
      const row = ExpressionUtil.getCurrentRowByPaths(paths, bindingData);
      if (row) {
        const propertyName = paths.pop();
        let parent = paths.reduce((object: any, path: string) => {
          return object && object[path] || null;
        }, entity);
        const node = { __items__: [...parent[propertyName]], ...row, __type__: 'List' };
        parent[propertyName] = node;
      }
    });
    return entity;
  }
  /**
   * è·åä¸»å®ä½åå§å­æ®µå
   */
  protected get entityOriginalNodeCode(): string {
    const repository = this.injector.get(Repository);
    return repository && repository.entityTypeInfo && repository.entityTypeInfo.entityInfo && repository.entityTypeInfo.entityInfo.originalCode || null;
  }
  /**
   * æé åéä¸ä¸æ
   * @param event 
   * @returns 
   */
  public buildStateContext() {
    const ns = this.frameContext.namespace;
    const appContext = this.injector.get<AppContext>(AppContext, null);
    const frameContexts = appContext.frameContextManager.getFrameContextsByNamespace(ns);
    const result = {};
    if (frameContexts && frameContexts.length > 0) {
      const anonymousFrameContext = frameContexts[0];
      const rootFrameContext = anonymousFrameContext.getVirtualRootFrameContext();
      if (rootFrameContext) {
        const uiState = rootFrameContext.viewModel.uiState;
        const propertyNames = Object.getOwnPropertyNames(uiState) || [];
        propertyNames.forEach((prop: string) => {
          if (prop.match(/^[a-zA-Z0-9_\$]+$/g) !== null) {
            result[prop] = uiState[prop];
          }
        });
      }
    }
    return result;
  }
}